<template>
    <v-app>
        <v-main>
            <router-view/>
            <loading-dialog></loading-dialog>
            <error-dialog></error-dialog>
            <text-dialog></text-dialog>
        </v-main>
    </v-app>
</template>

<script>
    import LoadingDialog from './components/dialog/LoadingDialog';
    import ErrorDialog from './components/dialog/ErrorDialog';
    import TextDialog from './components/dialog/SimpleTextDialog';
    export default {
        name: "App",
        components: {
            LoadingDialog,
            ErrorDialog,
            TextDialog
        },
        methods: {},
        data: () => ({})
    };
</script>
